import { Controller } from 'stimulus';

const FIELDS = ['street1', 'street2', 'country', 'region', 'city', 'postal_code', 'phone'];
const TRIGGER_URL_ATTRIBUTE = 'data-ui--twin-turbo-modal-trigger-url-value';

export default class extends Controller {
  static targets = ['dropdown', 'toggle', 'options'];

  #outsideClickHandler = (event) => {
    if (this.hasDropdownTarget && !this.dropdownTarget.contains(event.target)) {
      this.close();
    }
  };

  connect() {
    document.addEventListener('click', this.#outsideClickHandler, true);
  }

  disconnect() {
    document.removeEventListener('click', this.#outsideClickHandler, true);
  }

  toggle() {
    this.#setOpen(this.optionsTarget.classList.contains('hidden'));
  }

  close() {
    if (this.hasOptionsTarget) {
      this.#setOpen(false);
    }
  }

  async load(event) {
    event.preventDefault();

    const response = await fetch(event.currentTarget.href, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) {
      return;
    }

    const address = await response.json();
    FIELDS.forEach((field) => {
      const input = this.#input(field);
      if (!input) {
        return;
      }

      input.value = address[field] ?? '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    this.close();
  }

  prepareSave(event) {
    const trigger = event.currentTarget;
    const url = new URL(trigger.href, window.location.origin);

    FIELDS.forEach((field) => {
      const input = this.#input(field);
      if (input) {
        url.searchParams.set(`address[${field}]`, input.value);
      }
    });

    trigger.setAttribute(TRIGGER_URL_ATTRIBUTE, url);
  }

  #input(field) {
    return this.element.querySelector(`[name="address[${field}]"]`);
  }

  #setOpen(open) {
    this.optionsTarget.classList.toggle('hidden', !open);
    this.dropdownTarget.classList.toggle('load-preset--active', open);
    this.toggleTarget.setAttribute('aria-expanded', open);
  }
}
